// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StatisticsByDay_wrapper_2PxbX","day":"StatisticsByDay_day_3rxax","header":"StatisticsByDay_header_SsYdp"};